import { useAuth0 } from '@auth0/auth0-react';

/**
 * A visitor is "guest" when Auth0 has settled and reports no session.
 * Mirrors the iOS `.unauthenticated` phase — everyone unauthenticated
 * browses as a guest by default (login is opt-in). While Auth0 is still
 * loading we return `false` so the UI doesn't flash a guest layout before
 * a stored session resolves.
 */
export function useIsGuest(): boolean {
  const { isAuthenticated, isLoading } = useAuth0();
  return !isLoading && !isAuthenticated;
}
